import StarSharpIcon from "@mui/icons-material/StarSharp";
import { Paper } from "@mui/material";
import Grid from "@mui/material/Grid";
import dayjs from "dayjs";
import numberFormatter from "components/shared/numberFormatter";
import { CopyToClipboard } from "components/ui/atoms/CopyToClipboard";
import { LabelValueForText } from "components/ui/atoms/LabelValue";
import SectionGrid from "components/ui/atoms/SectionGrid";
import { ColorTag, DefaultTag } from "components/ui/atoms/Tag";
import TypographyWithMiss from "components/ui/atoms/TypographyWithMiss";

const CompanyView = ({ company }) => {
  return (
    <Paper sx={{ width: "100%", boxSizing: "border-box", p: 2 }}>
      <Grid container spacing={1}>
        <SectionGrid title="Domains" size={{ xs: 12, md: 6 }}>
          <Grid container spacing={0.5} pb={0.5}>
            {company.domains.map((domain, index) => (
              <Grid key={domain}>
                <CopyToClipboard text={domain}>
                  <DefaultTag
                    key={index}
                    label={domain}
                    color={
                      domain === company.best_domain ? "primary" : "default"
                    }
                    icon={
                      domain === company.best_domain ? (
                        <StarSharpIcon sx={{ scale: "0.8" }} />
                      ) : null
                    }
                  />
                </CopyToClipboard>
              </Grid>
            ))}
          </Grid>
        </SectionGrid>
        <SectionGrid title="Classification" size={{ xs: 12, md: 6 }}>
          <Grid container spacing={0.5} pb={0.5}>
            {company.sector_tags.map((tagId) => (
              <Grid key={tagId}>
                <ColorTag key={tagId} tagId={tagId} />
              </Grid>
            ))}
          </Grid>
          <Grid container spacing={0.5} pb={0.5}>
            {company.business_model_tags.map((tagId) => (
              <Grid key={tagId}>
                <ColorTag key={tagId} tagId={tagId} />
              </Grid>
            ))}
          </Grid>
          <Grid container spacing={0.5} pb={0.5}>
            {company.impact_model_tags.map((tagId) => (
              <Grid key={tagId}>
                <ColorTag key={tagId} tagId={tagId} />
              </Grid>
            ))}
          </Grid>
          <Grid container spacing={0.5} pb={0.5}>
            {company.mapping_and_certification_tags.map((tagId) => (
              <Grid key={tagId}>
                <ColorTag key={tagId} tagId={tagId} />
              </Grid>
            ))}
          </Grid>
        </SectionGrid>
        <SectionGrid title="Description" size={{ xs: 12, md: 6 }}>
          <TypographyWithMiss
            variant="body2"
            whiteSpace="pre-line"
            isMissing={company.description == ""}
          >
            {company.description}
          </TypographyWithMiss>
        </SectionGrid>
        <SectionGrid title="Information" size={{ xs: 12, md: 6 }}>
          <LabelValueForText
            label="Headquarter address"
            value={company.headquarter_address?.formatted_address}
            isMissing={
              company.headquarter_address === null ||
              company.headquarter_address.formatted_address.trim() === ""
            }
            sx={{ mb: 0.5 }}
          />
          <LabelValueForText
            label="Launch year"
            value={dayjs(company.founding_date).format("YYYY")}
            isMissing={company.founding_date == null}
            sx={{ mb: 0.5 }}
          />
          <LabelValueForText
            label="Latest fundraising"
            value={`${numberFormatter(
              company.last_fundraising_amount || NaN,
            )} €`}
            isMissing={company.last_fundraising_amount == null}
            sx={{ mb: 0.5 }}
          />
          <LabelValueForText
            label="Last fundraising year"
            value={dayjs(company.last_fundraising_date).format("YYYY")}
            isMissing={company.last_fundraising_date == null}
            sx={{ mb: 0.5 }}
          />
          <LabelValueForText
            label="Total raised"
            value={`${numberFormatter(company.total_amount_raised || NaN)} €`}
            isMissing={company.total_amount_raised == null}
            sx={{ mb: 0.5 }}
          />
          <LabelValueForText
            label="Employees"
            value={company.employees_count}
            isMissing={company?.employees_count == null}
            sx={{ mb: 0.5 }}
          />
          <LabelValueForText
            label="Investors"
            value={company.investors}
            isMissing={company.investors == ""}
            sx={{ mb: 0.5 }}
          />
        </SectionGrid>
        <SectionGrid title="Management" size={{ xs: 12, md: 6 }}>
          <TypographyWithMiss
            variant="body2"
            whiteSpace="pre-line"
            isMissing={company.management_data == ""}
          >
            {company.management_data}
          </TypographyWithMiss>
        </SectionGrid>
        <SectionGrid title="Impact" size={{ xs: 12, md: 6 }}>
          <TypographyWithMiss
            variant="body2"
            whiteSpace="pre-line"
            isMissing={company.impact == ""}
          >
            {company.impact}
          </TypographyWithMiss>
        </SectionGrid>
        <SectionGrid title="Equity Story" size={{ xs: 12, md: 6 }}>
          <TypographyWithMiss
            variant="body2"
            whiteSpace="pre-line"
            isMissing={company.equity_story == ""}
          >
            {company.equity_story}
          </TypographyWithMiss>
        </SectionGrid>
      </Grid>
    </Paper>
  );
};

export default CompanyView;
